// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedExternalIdUpsearchModel {
    static getAttributeTypeMap() {
        return SiteSharedExternalIdUpsearchModel.attributeTypeMap;
    }
}
SiteSharedExternalIdUpsearchModel.discriminator = undefined;
SiteSharedExternalIdUpsearchModel.additionalProperties = false;
SiteSharedExternalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=siteSharedExternalIdUpsearchModel.js.map